<template>
  <BasePanelWithHeader headerText="Agencies">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field v-model="searchText" prepend-inner-icon="mdi-magnify" label="Search" clearable>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton 
            small 
            @click="$refs.luAgencyForm.addLuAgency()" 
            icon="mdi-plus" 
            iconColor="white"
            buttonClass="primary"
            >Add Agency
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="luAgencies"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{item}">
          <BaseTooltipButton
          small
          @click="$refs.luAgencyForm.editLuAgency(item)"
          iconColor="primary"
          icon="mdi-pencil"
          >Edit Agency
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{item}">
          <BaseTooltipButton
            small
            @click="$refs.luAgencyDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Agency
            </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="luAgencyDelete"
        :delete="deleteLuAgency"
        @refresh="clearLookupCacheAndReloadLuAgencies">
        Are you sure you want to delete this agency?
      </BaseDeleteConfirm>
      <LuAgencyDialogForm 
        ref="luAgencyForm" 
        @refresh="clearLookupCacheAndReloadLuAgencies">
      </LuAgencyDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
  import { get, sync, commit, call } from 'vuex-pathify'
  import LuAgencyDialogForm from '@components/form/add-edit/LuAgencyDialog'
  export default {
      components: {
        LuAgencyDialogForm,
      },
      data: () => ({
        searchText: '',
      }),
      created() {
          this.loadLuAgencies()
      },
      computed: {
        ...get('luAgency', ['luAgencies', 'loading']),
        headers() {
          return [
            {
                text: '',
                align: 'center',
                value: 'edit',
                visible: true,
                sortable: false,
            },
            {
              text: 'ID',
              align: 'center',
              sortable: true,
              value: 'ID',
              visible: false,
            },
            {
              text: 'Number',
              align: 'center',
              sortable: true,
              value: 'Number',
              visible: true,
            },
            {
              text: 'Name',
              align: 'center',
              sortable: true,
              value: 'Name',
              visible: true,
            },
            {
              text: 'Abr',
              align: 'center',
              sortable: true,
              value: 'Abr',
              visible: true,
            },
            {
              text: '',
              align: 'center',
              value: 'delete',
              visible: false,
              sortable: false,
            },
          ]
        },
        filteredHeaders() {
          return this.headers.filter((h) => h.visible)
        },
      },
      methods: {
        ...call('luAgency', [
          'deleteLuAgency', 
          'loadLuAgencies', 
          'clearLookupCacheAndReloadLuAgencies'
        ]),
      }
  } 
  
</script>
<style>

</style>